import {PANDIUM_EVENT_ORIGINS, PANDIUM_SUCCESS} from './constants'

export const isPandiumOrigin = (origin: string): boolean => {
    return PANDIUM_EVENT_ORIGINS.includes(origin)
}

export const isPandiumSuccess = (message: string): boolean => {
    return message === PANDIUM_SUCCESS
}

const isValidUrl = (url: string) => {
    try {
        // eslint-disable-next-line no-new
        new URL(url)
    } catch (e) {
        return false
    }
    return true
}

export const hasAuthUrls = (
    authUrls: any,
): authUrls is {pleoAuthUrl: string; targetAuthUrl: string} => {
    return Boolean(
        authUrls &&
            authUrls.pleoAuthUrl &&
            authUrls.targetSystemAuthUrl &&
            isValidUrl(authUrls.pleoAuthUrl) &&
            isValidUrl(authUrls.targetSystemAuthUrl),
    )
}
